import { MODULE_SWITCHER_STATE } from 'mini-host-bridge/lib/nativeMessageConstants';
import { sendScenarioDataToHost } from 'mini-host-bridge/lib/utils/sendScenarioDataToHost';

export function hideNativeModuleSwitcher() {
    sendScenarioDataToHost({
        type: MODULE_SWITCHER_STATE,
        data: { mounted: false },
    });
}
